





































import Vue from 'vue';
import Component from 'vue-class-component';

import LoadingAnimation from 'frontend/components/LoadingAnimation.vue';
import Modal from 'frontend/components/Modal.vue';
import { mapGetters } from 'vuex';
import { ClassroomInviteInfo } from 'frontend/types/classrooms';
import { postData } from 'frontend/utils/ajax';

@Component({
  components: {
    LoadingAnimation,
    Modal,
  },
  computed: {
    ...mapGetters('joinClassroomFromCode', ['classroomInviteInfo']),
  },
})
export default class JoinClassroomModal extends Vue {
  private showModal = false;
  private classroomInviteInfo!: ClassroomInviteInfo | undefined;

  private async handleCloseJoinClassModal() {
    this.showModal = false;
    if (this.classroomInviteInfo) {
      await postData(this.classroomInviteInfo.join_class_decline_url);
    }
  }

  private joinClassroom() {
    if (this.classroomInviteInfo) {
      this.$store.dispatch(
        'globals/setJoinClassroomIntentKeyForSignup',
        this.classroomInviteInfo.join_class_intent_key,
      );
      this.$store.dispatch('signupModal/signup');
    }
    this.showModal = false;
  }

  private mounted() {
    if (this.classroomInviteInfo) {
      this.showModal = true;
    }
  }
}
